import {
  loadImage,
  isOverSize,
  fileToBase64,
  validateUrl,
  optimizeFile,
} from './Helper'
import { BannerBoundingSizeModel } from './BannerBoundingSize'
import { BannerRepository } from '.'
import { OverSizeImageError } from './Error'

export class EditBannerFormModel {
  constructor(data) {
    const { id, name, width, height, landingPageUrl, image } = data

    this.id = id
    this.name = name
    this.width = width
    this.height = height
    this.landingPageUrl = landingPageUrl
    this.image = image
    this.file = null
    this.isCheckOverCompressionRate = false
  }

  get boundingSize() {
    return new BannerBoundingSizeModel({
      width: this.width,
      height: this.height,
    })
  }

  get regularBoundingSize() {
    const halfWidth = Math.floor(this.width / 2)
    const halfHeight = Math.floor(this.height / 2)
    return (
      BannerBoundingSizeModel.find(this.boundingSize) ||
      BannerBoundingSizeModel.find({ width: halfWidth, height: halfHeight })
    )
  }

  get normalizedBoundingSize() {
    return this.regularBoundingSize || this.boundingSize
  }

  get normalizedLandingPageUrl() {
    return this.landingPageUrl.trim().replace(' ', '%20')
  }

  /**
   * 規定のサイズリストと一致しなければイレギュラーとみなす。
   * ただし、倍サイズ画像は許容する。
   */
  get hasIrregularBoundingSize() {
    return this.regularBoundingSize == null
  }

  get isOverSize() {
    return isOverSize(this.file)
  }

  /**
   * - URLバリデーション
   * - ファイルをセットした場合、サイズが規定に反していない
   */
  get isValid() {
    return (
      validateUrl(this.landingPageUrl) &&
      (this.file == null || !this.hasIrregularBoundingSize)
    )
  }

  setImage(image) {
    this.image = image
    this.width = image.naturalWidth
    this.height = image.naturalHeight
  }

  async changeImage(file) {
    const result = await optimizeFile(file)
    if (result instanceof Error) throw result
    const { optimizedFile, isCheckOverCompressionRate } = result
    this.isCheckOverCompressionRate = isCheckOverCompressionRate
    if (isOverSize(optimizedFile)) throw new OverSizeImageError()
    this.file = optimizedFile
    const image = await loadImage(optimizedFile)
    this.setImage(image)
  }

  async save() {
    try {
      const base64ImageData = await fileToBase64(this.file)
      const updated = await BannerRepository.update({
        id: this.id,
        name: this.name,
        width: this.normalizedBoundingSize.width,
        height: this.normalizedBoundingSize.height,
        landingPageUrl: this.normalizedLandingPageUrl,
        base64ImageData,
      })
      return updated
    } catch (e) {
      console.error(e)
      throw e
    }
  }
}
